"use client";
import { useState, useEffect } from "react";
import styles from "@/app/page.module.css";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import Footer from "@/app/ui/footer";
import { useMediaQuery } from "@mui/material"; 
import {adobeData, theme, generateAdobeDataRaceNo, generateAdobeDataHorseName, getSearchParams } from "@/app/utils/Common";
import HorseProfilePC from "./pc";
import HorseProfileMobile from "./mobile";
import { GET_HORSE_PROFILE } from "@/app/utils/request/query";
import { getHorseProfile, getGearInfo, getMeetingCountryAndHorseStatus } from "@/app/utils/request/requestList";
import { useSearchParams } from "next/navigation";
import {toDate, formattedDate}  from '@/app/utils/DayJS';
import "@/app/style/comm.scss";
import "@/app/style/simulcastfixture.scss";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext"; 

const HorseProfile: React.FC = () => {
  const { state: lang } = useLanguage();
  const { t } = lang; 
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const [horseProfileData, setHorseProfileData] = useState<any>(null);
  const [gearInfoData, setGearInfoData] = useState<any>([]);
  const [currentMtgData, setCurrentMtgData] = useState<any>(null);
  const [raceCountry, setRaceCountry] = useState<string>();
  const [horseStatus, setHorseStatus] = useState<string>();
  const [totalRun, setTotalRun] = useState<number>(0);
  const { h: horseParams, b_cid } = getSearchParams(new URLSearchParams(window.location.search));

  const [loading, setLoading] = useState(true); 
  //url: /[langCode]/overseas/horseprofile?h={meetingDate}/{meetingVenueCode}/{raceNo}/{simulcastHorseId}/{horseNo}
  //url: /en-us/overseas/horseprofile?h=20230127/S4/1/20230127S40101/1
  let meetingDate = "";
  let meetingVenueCode = "";
  let raceNo = 0;
  let simulcastHorseId = "";
  let horseNo = 0;
  const internalAd = b_cid || '';

  if (horseParams) {
    let params = horseParams?.split("/") || [];
    if (params.length > 4) {
      meetingDate = params[0];
      meetingVenueCode = params[1];
      raceNo = Number(params[2]);
      simulcastHorseId = params[3];
      horseNo = Number(params[4]);
    }
  }

  useEffect(() => {
    setLoading(true); 
    const meetingDT = formattedDate(toDate(meetingDate,"YYYYMMDD", true),"YYYY-MM-DD");
    const getHorseProfile_Call= new Promise((resolve, reject) => {
      getHorseProfile(
        {
          ids: [simulcastHorseId],
          meetingDate: meetingDate,
          raceNumber: raceNo.toString(),
        },
        GET_HORSE_PROFILE,
        "qids"
      )
        .then((res: any) => {
          const curHorseProfile = res?.simulcastHorse?.[0];
          setHorseProfileData(curHorseProfile);
          const curTotalRun = curHorseProfile?.performanceStats?.filter((x: any) => x.type == "LifeTime")?.[0]?.totalRun;
          setTotalRun(Number(curTotalRun ?? -1));  
        })
        .catch((e: any) => {
          console.log(e);
        }).finally(() => {
          resolve(true)
        });
    })

    const getMeetingCountryAndHorseStatus_Call= new Promise((resolve, reject) => {
      getMeetingCountryAndHorseStatus(meetingDT, meetingVenueCode)
      .then((res: any) => { 
        //const country = res?.raceMeetingProfile[0]?.country[0]?.code;
        const curRace = res?.raceMeetingProfile[0]?.races?.find((x: any) => x.no == raceNo);
        const country = curRace?.countryCodeNm?.english;
        const hStatus = curRace?.runners?.find((x: any) => x.no == horseNo).status;
        console.log("getMeetingCountryAndHorseStatus",meetingDT, res, country, horseStatus)
        //setCurrentMtgData(res);
        setRaceCountry(country);
        setHorseStatus(hStatus);
        //const seasonVal =  getSeason(country);
        //setSeason(seasonVal) 
      })
      .catch((e: any) => {
        console.log(e); 
      }).finally(() => {
        resolve(true);
      });
    })

    const getGearInfo_Call= new Promise((resolve, reject) => {
      getGearInfo(lang.langCode)
      .then((res: any) => { 
        setGearInfoData(res?.item?.children)
      })
      .catch((e: any) => {
        console.log(e);
      }).finally(() => {
        resolve(true);
      });
    })

    Promise.all([getHorseProfile_Call, getMeetingCountryAndHorseStatus_Call, getGearInfo_Call]).then((res: any) => {
    }).finally(() => {
      setLoading(false);  
    })
  }, []);

  useEffect(() => {
  if(horseProfileData) { 
    // adobeAnalysis
    adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "pageview", {
      pageId: "racing/simulcast",
      raceNo: generateAdobeDataRaceNo(toDate(meetingDate,"YYYYMMDD", true), meetingVenueCode, raceNo),
      horse: generateAdobeDataHorseName(toDate(meetingDate,"YYYYMMDD", true), meetingVenueCode, horseProfileData?.name_en),
      internalAd: b_cid,
      country: raceCountry
    })
  }
  }, [horseProfileData])


  const date = {}; 
  return (
    <>
    <main className={styles.main} style={isMobile ? {background: 'unset'} : {}}>
      {isMobile ? <></> : <Header />}
      {isMobile ? <></> : <HeaderNav />}
      {/* <Box sx={{width: "100%" }}> */}
      <div className="commBContent" style={{ padding: isMobile ? "" : "0 16px"}}> 
      {isMobile ? (
        <HorseProfileMobile
          data={horseProfileData}
          meetingDate={meetingDate}
          simulcastHorseId={simulcastHorseId}
          meetingVenueCode={meetingVenueCode}
          raceNo={raceNo}
          horseNo={horseNo}
          gearData={gearInfoData}
          raceCountry={raceCountry}
          horseStatus={horseStatus}
          totalRun={totalRun}
        />
      ) : (
        <HorseProfilePC
          data={horseProfileData}
          meetingDate={meetingDate}
          simulcastHorseId={simulcastHorseId}
          meetingVenueCode={meetingVenueCode}
          raceNo={raceNo}
          horseNo={horseNo}
          gearData={gearInfoData}
          raceCountry={raceCountry}
          horseStatus={horseStatus} 
          loading={loading}
          totalRun={totalRun}
        /> 
      )} 
      {/* </Box> */}
      </div>
      <Footer />
    </main>
    </>
  );
};
export default HorseProfile;